import { adminRoot } from "./config";
import { BiHome } from "react-icons/bi";

import { LuLayoutDashboard } from "react-icons/lu";
import PublicView from "src/views/PublicView";
import { Outlet } from "react-router-dom";
import Login from "src/views/user/Login";
import Denied from "src/views/user/Denied";
import ProtectedView from "src/views/ProtectedView";

import MainDashboard from "src/views/global/Dashboard";
import { FiUsers } from "react-icons/fi";
import { PiCubeDuotone, PiPresentationChart, PiSlidersDuotone } from "react-icons/pi";
import AddUser from "src/views/app/user/AddUser";
import Users from "src/views/app/user/Users";
import EditUser from "src/views/app/user/EditUser";
import Pricing from "src/views/global/Dashboard/Pricing";
import Prices from "src/views/global/Dashboard";



// routes create based on this array
const menuArray = [
    {
        path: "",
        element: <PublicView />,
        subs: [
            {
                path: "",
                element: <MainDashboard />,
            },
        ],
    },
    {
        icon: <PiPresentationChart size={30} />,
        label: "تابلو قیمت",
        path: `${adminRoot}/Prices`,
        inMenu: true,
        element: <PublicView />,
        permission: "viewDashboard",
        subs: [
            {
                icon: <BiHome />,
                label: "تابلو قیمت",
                path: `${adminRoot}/Prices`,
                element: <Prices />,
                inMenu: true,
            },
        ],
    },
    {
        icon: <PiSlidersDuotone size={30} />,
        label: "قیمت‌گذاری",
        path: `${adminRoot}/pricing`,
        inMenu: true,
        element: <PublicView />,
        permission: "viewDashboard",
        subs: [
            {
                icon: <BiHome />,
                label: "قیمت‌گذاری",
                path: `${adminRoot}/pricing`,
                element: <Pricing />,
                inMenu: true,
            },
        ],
    },
    {
        icon: <FiUsers />,
        label: "کاربران سیستم",
        inMenu: true,
        element: <PublicView />,
        path: `${adminRoot}/setting/user-management/user`,
        permission: "viewUserList",
        subs: [
            {
                icon: <PiCubeDuotone />,
                label: "کاربران سیستم",
                inMenu: false,
                element: <Users />,
                path: `${adminRoot}/setting/user-management/user`,
                permission: "viewUserList",
            },
            {
                icon: <PiCubeDuotone />,
                label: "افزودن کاربر جدید",
                inMenu: false,
                element: <AddUser />,
                path: `${adminRoot}/setting/user-management/user/add`,
                permission: "createNewUser",
            },
            // {
            //     icon: <PiCubeDuotone />,
            //     label: "ویرایش کاربر",
            //     inMenu: false,
            //     element: <EditUser />,
            //     path: `${adminRoot}/setting/user-management/user/edit`,
            //     permission: "editUser",
            // },
        ],
    },
    {
        path: "/user/",
        element: <Outlet />,
        subs: [
            {
                path: "login/",
                element: <Login />,
            },
            {
                path: "register/",
                element: <Login />,
            },
            {
                path: "denied/",
                element: <Denied />,
            },
        ],
    },
];
export default menuArray;
